import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import * as React from 'react';
import { TableCell } from '@mui/material';
export function GridHeaderCell(props) {
    const { column, text_color, ...rest } = props;
    // const createSortHandler = (property: keyof Data) => (
    //     event: React.MouseEvent<unknown>
    // ) => {
    //     onRequestSort(event, property);
    // };
    // const sort = () => sortColumn(column.name);
    // const direction =
    //     column.sortDirection === ColumnSortDirection.Ascending ||
    //     column.sortDirection === ColumnSortDirection.None
    //         ? 'asc'
    //         : 'desc';
    // const render = column.sortable ? (
    //     <Tooltip
    //         title="Нажмите, чтобы отсортировать"
    //         placement="bottom-start"
    //         enterDelay={300}
    //     >
    //         <TableSortLabel
    //             onClick={sort}
    //             onClick={createSortHandler(column.id)}
    //             direction={direction}
    //             active={column.sortDirection !== ColumnSortDirection.None}
    //         >
    //             {column.label}
    //         </TableSortLabel>
    //     </Tooltip>
    // ) : (
    //     column.label
    // );
    return (_createElement(TableCell, { ...rest, key: column.label, padding: column.label === '' ? 'none' : 'normal', variant: "head", style: { color: text_color } },
        _jsx("strong", { children: column.label })));
}
